import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import questionnaires from '@/view/questionnaires'

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, 
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, 
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '网站首页'
          }
        },
        {
          path: '/carrental',
          name: 'carrental',
          component: resolve => require(['@/view/carrental'], resolve),
          meta: {
            title: '我要租车'
          }
        },
{
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/site'], resolve),
          meta: {
            title: '站点分布'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '关于我们'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/seemore',
          name: 'seemore',
          component: resolve => require(['@/view/seeMore'], resolve),
          meta: {
            title: '最新资讯'
          }
        },
        {
          path: '/login',
          name: 'login',
          component: resolve => require(['@/view/login'], resolve),
          meta: {
            title: '登录/注册'
          }
        },
        {
          path: '/cooperate',
          name: 'cooperate',
          component: resolve => require(['@/view/cooperate'], resolve),
          meta: {
            title: '我要加盟/合作'
          }
        },
        {
          path: '/questionnaire',
          name: 'questionnaire',
          component: resolve => require(['@/view/questionnaire'], resolve),
          meta: {
            title: '问卷调查'
          }
        },
      ]
    },
    {
      path: '/questionnaires',
      name: 'questionnaires',
      component: questionnaires,
      meta: {
        title: '问卷调查'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js